// extracted by mini-css-extract-plugin
module.exports = {"notification":"styles_notification__UZy6Z","content":"styles_content__qEMFc","closeButton":"styles_closeButton__p9IAm"};